/* istanbul ignore file - zod entity */

import { z } from 'zod';

export const ProductDetails = z.object({
  productName: z
    .string({ required_error: 'instructions:create.CAD.name.validation.required' })
    .min(1, 'instructions:create.CAD.name.validation.required')
    .max(50, 'instructions:create.CAD.name.validation.maxLength'),
  cadFile: z.custom<FileList>(
    (data) => {
      if (!(data instanceof FileList) || data.length === 0) {
        return false;
      }

      const item = data.item(0);
      if (item == null || !item.name.endsWith('.zip') || item.size <= 1) {
        return false;
      }

      return true;
    },
    (input) => {
      if (input instanceof FileList) {
        if (input.length === 0) {
          return { message: 'instructions:create.CAD.file.validation.required' };
        }

        if (input.length > 1) {
          return { message: 'instructions:create.CAD.file.validation.maxLength' };
        }

        const item = input.item(0);

        if (item == null) {
          return { message: 'instructions:create.CAD.file.validation.required' };
        }

        if (!item.name.endsWith('.zip')) {
          return { message: 'instructions:create.CAD.file.validation.format' };
        }

        if (item.size <= 1) {
          return { message: 'instructions:create.CAD.file.validation.empty' };
        }
      }

      return { message: 'instructions:create.CAD.file.validation.required' };
    }
  ),
});
export type ProductDetails = z.infer<typeof ProductDetails>;

export const UpdateProductDetails = z.object({
  productName: z
    .string({ required_error: 'instructions:manage.overview.name.validation.required' })
    .min(1, 'instructions:manage.overview.name.validation.required')
    .max(50, 'instructions:manage.overview.name.validation.maxLength'),
});
export type UpdateProductDetails = z.infer<typeof UpdateProductDetails>;
